import React from 'react';
import { animated } from 'react-spring';
import styles from '../Dashboards.module.css';
import { clampPanel } from '../helpers';

function PanelDragPreview({ dragType, gridOffsets, dimensions, rowCount }) {
  if (dragType) {
    const [columnOffset, rowOffset] = gridOffsets;
    let { row, column, width, height } = dimensions;

    if (dragType === 'move') {
      row += rowOffset;
      column += columnOffset;
    } else if (dragType === 'resize') {
      height += rowOffset;
      width += columnOffset;
    }

    ({ row, column, width, height } = clampPanel({
      row,
      column,
      width,
      height,
      rowCount,
    }));

    return (
      <animated.div
        className={styles.PanelDragPreview}
        style={{
          gridRowStart: row,
          gridRowEnd: `span ${height}`,
          gridColumnStart: column,
          gridColumnEnd: `span ${width}`,
        }}
      />
    );
  } else {
    return null;
  }
}

export default animated(PanelDragPreview);
